import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface TimeFieldModel extends BaseFieldModel {
  value: string | undefined;
  defaultValue: string | undefined;
  placeholder: CultureTextModel[] | string;
  type: FieldType.Time;
}

export class TimeField extends BaseField implements TimeFieldModel {
  public value: string | undefined;
  public defaultValue: string | undefined;
  public placeholder: CultureTextModel[] | string = '';
  public type: FieldType.Time = FieldType.Time;

  constructor(cultures: string[]) {
    super(FieldType.Time, cultures);

    this.placeholder = [];

    for (const culture of cultures) {
      this.placeholder.push({ culture, value: '' });
    }
  }
}
